module.exports = __webpack_public_path__ + "static/media/GQ.b89fe843.png";